import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiCCardInfoModule } from '@wlp/ui-c-card-info';

let UiCUserCardGridComponent = class UiCUserCardGridComponent {
    constructor() {
        this.onChange = new EventEmitter();
    }
    onChangeValue(event) {
        this.onChange.emit(event);
    }
};
__decorate([
    Input()
], UiCUserCardGridComponent.prototype, "flagGrid", void 0);
__decorate([
    Input()
], UiCUserCardGridComponent.prototype, "listData", void 0);
__decorate([
    Output()
], UiCUserCardGridComponent.prototype, "onChange", void 0);
UiCUserCardGridComponent = __decorate([
    Component({
        selector: 'ui-c-user-card-grid',
        template: "<div class=\"position-fixed card-position\" *ngIf=\"flagGrid\">\n  <div class=\"dropdown-menu dropdown-menu-anim-up content-notification\">\n    <ion-card class=\"user-card content-grid\">\n      <ion-content class=\"content-grid\" [scrollEvents]=\"true\">\n        <ion-row>\n          <ion-col size=\"6\" *ngFor=\"let el of listData\">\n            <ion-card *ngIf=\"el.isVisible\" class=\"d-flex flex-column justify-content-around card-info-grid\" (click)=\"onChangeValue(el)\">\n              <ion-item lines=\"none\">\n                <ion-img [src]=\"el.img\" class=\"mx-auto ion-image\"></ion-img>\n              </ion-item>\n              <ion-item class=\"ion-text-center\" lines=\"none\">\n                <ion-label>{{ el.label }}</ion-label>\n              </ion-item>\n            </ion-card>\n          </ion-col>\n        </ion-row>\n      </ion-content>\n    </ion-card>\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCUserCardGridComponent);

let UiCUserCardGridModule = class UiCUserCardGridModule {
};
UiCUserCardGridModule = __decorate([
    NgModule({
        declarations: [UiCUserCardGridComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            UiCCardInfoModule,
            UiCCardInfoModule,
            AngularSvgIconModule.forRoot(),
        ],
        exports: [UiCUserCardGridComponent],
    })
], UiCUserCardGridModule);

/*
 * Public API Surface of ui-c-user-card-grid
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCUserCardGridComponent, UiCUserCardGridModule };
//# sourceMappingURL=wlp-ui-c-user-card-grid.js.map
